var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtraRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1408 1512",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h1408v1512h-1408z",
    fill: "#FDFDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(808)",
    d: "m0 0h161l5 12 3 15 16 3 16 8 10 9 7 11 4 10 2 11v36l-3 11-8 9-9 4-4 1h-9l-8-3-6-4-6-7-3-10-1-31-55-1v59l-3 16-7 14-8 9-14 9-12 4-7 1h-61l1 55 16 3 9 4 10 6 8 8 8 14 3 10 1 15v53l55-1 3-16 4-10 8-11 7-7 12-7 14-4 8-1 1-55h-33l-8-3-6-4-6-7-3-9v-10l4-11 5-5 5-4 9-3h41l12 3 12 6 12 11 8 14 3 10 1 7v65l-2 12-5 12-8 11-9 7-14 7-9 3-8 1-3 16-8 16-9 10-13 8-12 4-7 1h-341v112l-2 16-4 10-7 10-5 5-9 7-14 6-14 3-1 29-2 8-4 8-9 7-9 3h-8l-9-3-6-4-6-7-3-9v-33h-112v30l-2 9-6 9-9 6-7 2h-8l-9-3-6-4-6-7-3-9v-33h-33l-8-3-6-4-6-7-3-9v-11l4-10 5-5 5-4 8-3 89-1 1-32 4-11 4-5 10-6 4-1h11l11 4 7 7 4 9 1 5v31l55-1 3-16 5-11 6-9 8-8 12-7 14-4 9-1v-55h-33l-8-3-6-4-6-7-3-9v-10l4-11 8-8 10-4 33-1 1-32 4-11 8-8 10-4h11l11 4 7 7 4 9 1 6v30l55-1 3-15 5-12 7-10 10-9 15-7 7-2 9-1 3-16 5-11 6-9 8-8 12-7 14-4 9-1-1-166-32-1-8-3-6-4-6-7-3-9v-10l4-11 5-5 5-4 9-3h41l12 3 12 6 10 9 7 10 6 15 2 12h54l1-55h-31l-10-3-6-4-5-8-4-9z",
    fill: "#211F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,654)",
    d: "m0 0 5 3 9 10 7 14 2 6 1 13h34l10 4 5 4 6 11 1 5v8l-3 10-8 9-8 4-5 1h-32v112h9l13 4 11 6 10 9 8 13 4 11 2 13h8l15 5 12 7 8 8 8 14 3 9 2 12 118 1 13 3 12 6 10 9 7 10 5 12 2 11v36l-3 11-8 9-12 5h-9l-9-3-6-4-6-7-3-9v-33l-111 1-3 16-7 14-8 10-13 9-10 4-12 2h-60v56h33l11 4 7 7 4 8 1 5v8l-3 10-7 8-10 5-5 1h-31v56l56-1v-31l2-8 6-9 10-6 4-1h11l11 4 8 8 3 7 1 6v35l-3 15-7 14-8 9-14 9-12 4-11 2-1 58-3 16-7 14-9 10-13 8-12 4-5 1h-7v56l55-1 1-32 4-11 8-8 10-4h11l11 4 7 7 4 8 1 6v34l-3 16-4 9h-129z",
    fill: "#211F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1334,196)",
    d: "m0 0h11l11 4 7 7 4 9 1 7v133l1 7 12 2 13 5 11 7 3 2v418l-13 8-11 5-15 3-1 30-3 10-6 8-10 6-4 1h-10l-8-3-6-4-6-7-3-9v-33h-33l-8-3-6-4-6-7-3-9v-10l4-11 8-8 10-4 33-1 3-16 5-11 6-9 8-8 12-7 14-4 9-1v-55h-32l-9-3-6-4-6-7-3-9v-10l4-11 4-5 10-6 4-1h34v-112h-88l-9-3-6-4-6-7-3-9v-10l4-11 5-5 5-4 8-3h34v-56h-88l-9-3-6-4-6-7-3-9v-10l4-11 5-5 5-4 8-3 33-1 3-16 5-11 6-9 8-8 12-7 14-4 9-1v-32l4-11 4-5 10-6z",
    fill: "#211F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1110,308)",
    d: "m0 0h11l11 4 7 7 4 9 1 5v87h9l13 4 11 6 10 9 7 11 5 13 1 6v12l-3 14-7 14-8 9-14 9-12 4-7 1-60 1-3 15-5 12-8 11-7 6-12 7-10 3-7 1h-117v112h33l11 4 7 7 4 8 1 5v8l-4 11-7 8-9 4-6 1h-118l-9-3-6-4-5-6-3-6-1-4v-10l4-11 4-5 10-6 4-1h34v-118l3-14 6-12 11-12 10-6 12-5 14-2v-32l4-11 8-8 10-4h11l11 4 7 7 4 9 1 6v30l55-1 3-16 5-11 6-9 8-8 12-7 14-4 9-1v-55h-33l-8-3-6-4-6-7-3-9v-10l4-11 7-7 7-4 4-1h34v-33l3-9 5-7 10-6z",
    fill: "#211F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(718,980)",
    d: "m0 0h11l9 3 9 8 4 9 1 6v30l55-1 1-31 3-10 5-7 10-6 4-1h11l11 4 7 7 4 9 1 6v30l55-1 1-31 2-8 6-9 10-6 4-1h11l11 4 7 7 4 9 1 6v199l-2 14-4 11-9 13-7 6-12 7-16 4h-38l-9-3-6-4-6-7-3-9v-10l4-11 5-5 5-4 8-3h34l-1-55-15-3-12-5-12-9-8-10-5-10-3-12-1-7-199-1-9-3-6-4-5-6-4-10v-10l4-11 5-5 5-4 8-3 33-1 1-32 4-11 8-8z",
    fill: "#211F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1390,1148)",
    d: "m0 0h11l7 2v362h-96v-28h-32l-9-3-6-4-5-6-4-10v-10l4-11 5-5 5-4 9-3h33l-1-111-15-3-12-5-12-9-8-10-6-13-2-9v-15l3-13 6-12 11-12 13-8 9-3 7-1 62-1 1-31 3-10 4-6 9-6z",
    fill: "#211F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1249,28)",
    d: "m0 0h159v56h-96v81l-2 14-6 9-9 6-6 2h-9l-9-3-6-4-6-7-3-9v-33l-55 1-3 16-8 16-9 10-13 8-12 4-5 1h-7v31l-3 10-6 8-8 5-6 2h-10l-8-3-6-4-6-7-3-9v-33h-33l-8-3-6-4-6-7-3-9v-10l4-11 4-5 10-6 4-1 89-1 3-16 4-10 8-11 7-7 12-7 13-4 9-1 3-16 5-11 6-9 8-8 12-7 9-3z",
    fill: "#211F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(663,1316)",
    d: "m0 0h41l12 3 12 6 11 10 7 11 4 10 2 15v57l55-1 1-88 4-11 4-5 10-6 4-1h11l11 4 7 7 4 9 1 6v170h-272l2-5 9-10 10-7 12-5 14-2 3-16 4-10 8-11 7-7 12-7 14-4 9-1v-55h-32l-9-3-6-4-6-7-3-9v-10l4-11 8-8z",
    fill: "#211F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(550,1036)",
    d: "m0 0h11l11 4 7 7 4 9 1 5v35l-3 15-7 14-9 10-13 8-12 4-7 1-60 1-3 16-8 16-8 9-14 9-12 4-7 1-116 1-3 16-8 16-9 10-13 8-12 4-6 1h-38l-9-3-6-4-6-7-3-9v-10l4-11 5-5 5-4 8-3 33-1 3-16 4-10 8-11 10-9 15-7 15-3h2v-33l4-10 4-5 10-6 4-1h11l11 4 7 7 4 9 1 6v30l55-1 3-16 4-10 8-11 10-9 12-6 12-3 63-1 1-32 3-9 7-8 8-5z",
    fill: "#211F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(551,644)",
    d: "m0 0h10l10 4 7 6 5 10 1 7v29h90l10 4 7 7 4 8 1 5v8l-4 11-7 8-9 4-6 1h-86v56h119l13 3 12 6 10 9 7 10 5 12 2 11v35l-2 9-5 8-6 5-10 4h-9l-9-3-6-4-6-7-3-9v-33h-118l-14-3-13-7-11-10-7-11-4-12-1-7v-149l2-9 4-6 8-7z",
    fill: "#211F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(472)",
    d: "m0 0h161l5 12 1 6 1 122h33l11 4 7 7 4 8 1 5v8l-3 9-4 6-8 6-10 3h-31v83l-1 9-4 8-5 5-8 5-5 2h-9l-11-4-8-7-4-8-1-4v-33h-33l-8-3-6-4-6-7-3-9v-10l4-11 8-8 10-4 33-1v-110l-15-3-12-5-11-8-7-8-6-10-4-14-1-8-31-1-11-4-6-5-7-15z",
    fill: "#211F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(998,756)",
    d: "m0 0h11l11 4 7 7 4 9 1 6v30h33l11 4 7 7 4 8 1 5v8l-3 9-6 8-8 5-8 2h-31v56h90l10 4 7 7 4 8 1 5v8l-3 10-8 9-9 4-5 1h-93l-11-2-16-8-10-9-7-11-5-12-1-7v-63h-87l-8-2-8-5-5-6-4-10v-10l4-11 5-5 5-4 8-3 89-1 1-31 3-10 5-7 10-6z",
    fill: "#211F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(663,476)",
    d: "m0 0h40l13 3 12 6 11 10 8 13 4 12 2 11 33 1 10 4 7 7 4 8 1 5v8l-3 9-4 6-6 5-11 4h-32v56h33l11 4 7 7 4 8 1 5v8l-4 11-6 7-10 5-6 1h-36l-11-2-16-8-11-10-8-14-3-9-2-12-88-1-8-3-8-6-5-8-2-6v-10l5-12 9-8 8-3 89-1 1-55h-33l-8-3-6-4-5-6-4-10v-10l4-11 5-5 5-4z",
    fill: "#211F20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(438,812)",
    d: "m0 0h11l11 4 7 7 4 9 1 6 1 29 16 3 9 4 10 6 8 8 8 14 3 10 1 7v65l-3 15-7 14-9 10-15 9-9 3-6 1h-14l-12-3-12-6-10-8-8-11-5-11-3-16-15-3-12-5-12-9-8-10-6-13-2-9v-15l3-13 6-12 11-12 13-8 14-4 8-1 1-32 3-9 5-7 10-6z",
    fill: "#211F20"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(464,84)",
    d: "m0 0h16l12 3 12 6 10 9 7 10 5 11 2 10v13l-4 16-6 11-9 10-13 8-12 4-11 2-1 55h33l10 4 8 7 4 8 1 5v8l-4 11-7 8-9 4-5 1h-38l-12-3-14-7-11-10-8-14-4-13-1-8-15-3-12-5-12-9-8-10-6-13-2-8v-16l4-16 6-10 9-10 9-6 8-4 10-3 9-1 3-16 4-10 8-11 7-7 12-7 9-3z",
    fill: "#211F20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1222,812)",
    d: "m0 0h11l11 4 7 7 4 9 1 6 1 29 12 2 13 5 11 7 7 7 8 14 4 16 1 5 32 1 11 4 7 7 4 8 1 5v8l-3 10-7 8-10 5-5 1h-31v85l-2 10-6 9-9 6-7 2h-8l-9-3-6-4-6-7-3-9-1-144-87-1-9-3-6-4-6-7-3-9v-10l4-11 8-8 10-4h34v-32l2-8 6-9 10-6z",
    fill: "#211F20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1080,1036)",
    d: "m0 0h41l11 4 5 4 6 11 1 4v9l-4 11-7 8-9 4-4 1h-32v56l111-1 1-32 3-9 7-8 8-5 4-1h11l11 4 5 4 4 6 2 5 1 6v34l-3 16-7 14-8 9-14 9-12 4-8 1h-122l-14-3-11-6-10-8-8-11-5-11-2-10v-69l3-14 6-12 11-12 13-8 9-3z",
    fill: "#211F20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(214,252)",
    d: "m0 0h11l9 3 8 7 5 10 1 6v30h146l10 4 7 7 4 8 1 5v8l-4 11-6 7-10 5-6 1h-142l-1 13-5 13-9 13-10 8-12 6-13 3h-13l-12-3-12-6-10-8-8-11-5-11-2-9v-15l3-13 6-12 11-12 10-6 12-5 13-2 1-32 3-9 5-7 10-6z",
    fill: "#211F20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(214,700)",
    d: "m0 0h11l11 4 7 7 4 9 1 5 1 30 16 3 9 4 11 7 7 7 8 14 3 9 1 5v14l-3 13-7 14-7 8-10 7-10 5-10 3-8 1-3 16-8 16-8 9-14 9-12 4-6 1h-38l-9-3-6-4-6-7-3-9v-11l4-10 5-5 5-4 8-3 33-1 1-55h-33l-8-3-6-4-6-7-3-9v-10l4-11 8-8 10-4h34v-33l3-9 7-8 8-5z",
    fill: "#211F20"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1136,1372)",
    d: "m0 0h98l10 4 7 7 4 8 1 13-4 11-6 7-10 5-5 1-86 1-3 16-8 16-8 9-14 9-12 4-7 1-60 1-3 16-4 9-1 2h-105l1-9 4-8 7-7 10-4 33-1 3-16 4-10 8-11 10-9 12-6 12-3 63-1 3-16 4-10 8-11 7-7 12-7 9-3z",
    fill: "#211F20"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1248,532)",
    d: "m0 0h41l11 4 7 7 4 8 1 5v8l-3 10-8 9-9 4-5 1h-31v56h33l11 4 7 7 4 8 1 5v8l-4 11-7 8-9 4-6 1h-36l-11-2-14-7-10-8-8-11-5-11-2-10v-69l3-14 6-12 11-12 13-8 9-3z",
    fill: "#211F20"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,476)",
    d: "m0 0h32l12 3 12 6 10 9 7 10 5 12 3 15 32 1 11 4 7 7 4 8 1 5v9l-4 10-7 8-9 4-5 1h-31v31l-3 10-6 8-10 6-4 1h-10l-8-3-6-4-6-7-3-9-1-88-23-1z",
    fill: "#211F20"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(998,1260)",
    d: "m0 0h11l11 4 7 7 4 9 1 5v31h33l11 4 7 7 4 8 1 5v8l-4 11-7 8-9 4-6 1h-118l-9-3-6-4-5-6-3-6-1-4v-10l4-11 5-5 5-4 8-3 33-1 1-32 3-9 7-8 8-5z",
    fill: "#211F20"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(352,1260)",
    d: "m0 0h97l11 4 7 7 4 8 1 5v8l-4 11-6 7-10 5-6 1h-86v31l-3 10-4 6-8 6-9 3h-8l-9-3-6-4-6-7-3-9v-40l4-16 6-10 9-10 9-6 8-4z",
    fill: "#211F20"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(606,1148)",
    d: "m0 0h11l11 4 7 7 4 9 1 5v90l-3 16-6 12-8 10-10 7-10 5-14 3h-37l-9-3-6-4-5-6-3-6-1-4v-10l4-11 5-5 5-4 9-3h33v-89l4-11 8-8z",
    fill: "#211F20"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h240l-2 4-5 7-10 8-12 6-7 2-8 1-115 1-3 16-7 14-8 10-13 9-14 5-7 1h-29z",
    fill: "#211F20"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(382,1372)",
    d: "m0 0h124l10 4 7 7 4 8 1 5v8l-4 12-7 7-9 4-6 1h-118l-9-3-6-4-6-8-3-8v-10l4-11 5-5 5-4z",
    fill: "#211F20"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(744,1148)",
    d: "m0 0h41l11 4 7 7 4 8 1 5v8l-3 10-8 9-9 4-5 1h-31v31l-3 11-8 9-12 5h-10l-8-3-6-4-6-7-3-9v-40l4-16 6-10 9-10 9-6 8-4z",
    fill: "#211F20"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(383,644)",
    d: "m0 0h40l13 3 12 6 11 10 7 11 4 10 2 11v35l-2 9-6 9-9 6-6 2h-10l-8-3-6-4-6-7-3-9v-33h-32l-9-3-6-4-5-6-4-10v-10l4-11 4-5 8-5z",
    fill: "#211F20"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(270,420)",
    d: "m0 0h67l11 4 7 7 4 8 1 5v8l-3 10-8 9-9 4-6 1h-62l-9-3-6-4-6-7-3-9v-10l4-11 8-8z",
    fill: "#211F20"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(103,196)",
    d: "m0 0h67l10 4 5 4 6 11 1 5v8l-4 11-7 8-9 4-6 1h-62l-9-3-6-4-5-6-4-10v-10l4-11 4-5 10-6z",
    fill: "#211F20"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(214,84)",
    d: "m0 0h11l11 4 7 7 4 8 1 6v61l-2 9-6 9-9 6-6 2h-9l-9-3-6-4-6-7-3-9v-65l3-10 7-8 8-5z",
    fill: "#211F20"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,919)",
    d: "m0 0 9 2 13 3 2 2 3 14 5 12 9 12 13 9 14 5 12 3v54l-1 1h-55l-1-29-2-10-5-8-6-5-10-4z",
    fill: "#FDFDFD"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,196)",
    d: "m0 0 5 1 8 4 7 8 3 7 1 5v168l-1 11-4 8-5 6-10 5-4 1z",
    fill: "#211F20"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1406,1245)",
    d: "m0 0h2v127h-40l-1-11v-91l1-9 7-2 12-3 12-6z",
    fill: "#FDFDFD"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1368,1428)",
    d: "m0 0h40v84h-40l-1-9v-73z",
    fill: "#FDFDFD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(752,308)",
    d: "m0 0h55l1 1v55h-56l-1-35v-12z",
    fill: "#FDFDFD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(774,1260)",
    d: "m0 0h11l11 4 7 7 4 9 1 4v8l-4 11-6 7-10 5-4 1h-9l-8-3-6-4-5-6-4-10v-10l4-11 4-5 10-6z",
    fill: "#211F20"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1054,700)",
    d: "m0 0h11l11 4 7 7 4 9 1 5v7l-4 11-6 7-10 5-3 1h-10l-8-3-6-4-5-6-3-6-1-4v-10l4-11 4-5 10-6z",
    fill: "#211F20"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1167,980)",
    d: "m0 0h10l9 3 9 8 4 8 1 5v8l-4 11-6 7-10 5-4 1h-8l-9-3-6-4-6-7-3-9v-10l4-11 4-5 10-6z",
    fill: "#211F20"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(214,1316)",
    d: "m0 0h11l11 4 7 7 4 9 1 4v8l-4 11-6 7-10 5-4 1h-8l-9-3-6-4-6-7-3-9v-10l4-11 8-8z",
    fill: "#211F20"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(774,924)",
    d: "m0 0h11l11 4 7 7 4 9 1 5v7l-4 11-6 7-10 5-3 1h-10l-10-4-7-6-5-9-1-4v-10l4-11 4-5 10-6z",
    fill: "#211F20"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1110,1260)",
    d: "m0 0h11l9 3 9 8 4 9 1 5v7l-4 11-6 7-10 5-4 1h-8l-9-3-6-4-6-7-3-9v-10l4-11 8-8z",
    fill: "#211F20"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(662,924)",
    d: "m0 0h11l11 4 7 7 4 8 1 13-4 11-6 7-10 5-4 1h-8l-9-3-6-4-6-7-3-9v-10l4-11 8-8z",
    fill: "#211F20"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(327,84)",
    d: "m0 0h10l11 4 7 7 4 8 1 5v8l-4 11-6 7-10 5-4 1h-8l-11-4-8-7-4-8-1-4v-10l4-11 4-5 8-5z",
    fill: "#211F20"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(382,28)",
    d: "m0 0h11l9 3 9 8 4 9 1 5v7l-4 11-6 7-10 5-4 1h-8l-9-3-6-4-6-7-3-9v-10l4-11 8-8z",
    fill: "#211F20"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(271,1372)",
    d: "m0 0h10l11 4 7 7 4 8 1 5v8l-4 11-6 7-10 5-4 1h-8l-9-3-6-4-6-8-3-8v-10l4-11 4-5 8-5z",
    fill: "#211F20"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(159,1372)",
    d: "m0 0h10l11 4 7 7 4 8 1 5v8l-4 11-6 7-10 5-4 1h-8l-11-4-8-7-4-8-1-4v-10l4-11 8-8z",
    fill: "#211F20"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(103,812)",
    d: "m0 0h10l11 4 7 7 4 9 1 4v8l-4 11-6 7-10 5-4 1h-8l-9-3-6-4-6-7-3-9v-10l4-11 8-8z",
    fill: "#211F20"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(271,644)",
    d: "m0 0h10l11 4 7 7 4 8 1 5v8l-4 11-6 7-10 5-4 1h-8l-9-3-6-4-5-6-4-10v-10l4-11 4-5 8-5z",
    fill: "#211F20"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(999,420)",
    d: "m0 0h10l11 4 7 7 4 8 1 5v8l-4 11-6 7-10 5-4 1h-8l-11-4-8-7-4-8-1-4v-10l4-11 8-8z",
    fill: "#211F20"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(270,28)",
    d: "m0 0h11l9 3 9 8 4 9 1 5v7l-4 11-6 7-10 5-4 1h-8l-9-3-6-4-6-7-3-9v-10l4-11 8-8z",
    fill: "#211F20"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(215,588)",
    d: "m0 0h10l11 4 7 7 4 9 1 4v8l-4 11-6 7-10 5-4 1h-9l-10-4-7-6-5-9-1-4v-10l4-11 5-5 5-4z",
    fill: "#211F20"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(438,420)",
    d: "m0 0h11l11 4 7 7 4 8 1 5v8l-4 11-6 7-10 5-4 1h-8l-11-4-8-7-4-8-1-4v-10l4-11 8-8z",
    fill: "#211F20"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1223,196)",
    d: "m0 0h10l11 4 7 7 4 8 1 5v8l-4 11-6 7-10 5-4 1h-8l-9-3-6-4-5-6-4-10v-10l4-11 8-8z",
    fill: "#211F20"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(550,1428)",
    d: "m0 0h11l11 4 7 7 4 9 1 5v7l-4 11-6 7-10 5-4 1h-8l-9-3-6-4-6-8-3-8v-10l4-11 4-5 8-5z",
    fill: "#211F20"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(215,1092)",
    d: "m0 0h10l11 4 7 7 4 8 1 5v8l-4 11-6 7-10 5-4 1h-8l-9-3-6-4-6-8-3-8v-10l4-11 8-8z",
    fill: "#211F20"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1111,588)",
    d: "m0 0h10l11 4 7 7 4 9 1 4v8l-4 11-6 7-10 5-4 1h-8l-9-3-6-4-6-8-3-8v-10l4-11 8-8z",
    fill: "#211F20"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(215,476)",
    d: "m0 0h10l11 4 7 7 4 9 1 5v7l-4 11-6 7-10 5-4 1h-8l-9-3-6-4-6-8-3-8v-10l4-11 5-5 5-4z",
    fill: "#211F20"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(606,980)",
    d: "m0 0h11l11 4 7 7 4 9 1 5v7l-4 11-5 6-9 5-6 2h-8l-11-4-8-7-4-8-1-4v-10l4-11 8-8z",
    fill: "#211F20"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(270,196)",
    d: "m0 0h11l11 4 7 7 4 9 1 4v8l-4 11-6 7-10 5-4 1h-8l-11-4-7-6-5-10-1-3v-10l4-11 8-8z",
    fill: "#211F20"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(46,140)",
    d: "m0 0h11l11 4 7 7 4 9 1 5v7l-4 11-5 6-8 5-7 2h-8l-11-4-7-6-5-9-1-4v-10l4-11 8-8z",
    fill: "#211F20"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(271,1484)",
    d: "m0 0h41l12 3 10 5 10 8 8 11v1h-104l1-9 4-8 7-7z",
    fill: "#211F20"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1032)",
    d: "m0 0h104l-2 4-6 8-12 9-12 5-11 2h-35l-9-2-8-5-5-8-4-9z",
    fill: "#211F20"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1391,980)",
    d: "m0 0h17v56h-15l-9-2-8-6-6-8-2-7v-10l4-11 4-5 8-5z",
    fill: "#211F20"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(752,1484)",
    d: "m0 0h56v28h-56z",
    fill: "#FDFDFD"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,1316)",
    d: "m0 0h24v55l-13 3-7 2h-4z",
    fill: "#FDFDFD"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1222,1484)",
    d: "m0 0h11l11 4 7 7 5 12v5h-56l1-9 4-8 5-5 8-5z",
    fill: "#211F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraRounded);
export default __webpack_public_path__ + "static/media/extra-rounded.18f08768776190b288fe796109a85d47.svg";
export { ForwardRef as ReactComponent };